export enum IndustryEnum {
    RETAIL = 'Retail',
    RESTAURANT = 'Restaurant',
    ECOMMERCE = 'eCommerce',
    SERVICES_PROFESSIONAL_SERVICES = 'Services/Professional Services',
    TRAVEL_ENTERTAINMENT = 'Travel/Entertainment',
    NON_PROFIT = 'Non-Profit',
    GOVERNMENT = 'Government',
    HEALTHCARE = 'Healthcare',
    OTHER = 'Other'
}

export class Merchant {
    /**
     * So constructors in this project are really validators.
     * Their intention is to enforce the contract between the
     * client and the server. It's important to know that the 
     * .forEach() below will only loop over initialized fields.
     * That's why fields are either T|undefined or = null.
     */
    constructor(merchant: Partial<Merchant>) {
        Object.keys(this).forEach(key => {
            if (merchant[key as keyof Merchant] == null)
                throw Error(`${key} cannot be null`);
        });
        Object.assign(this, merchant);
    }

    id: string | null = null;

    createdAt: Date | null = null;
    isApproved: boolean | null = null;
    isArchived: boolean | null = null;

    companyName: string | null = null;

    contactFirstName: string | null = null;
    contactLastName: string | null = null;
    contactEmail: string | null = null;
    contactPhone: string | undefined;

    industry: IndustryEnum | null = null;

    logoUrl: string | undefined;

    ownerId: string | null = null;

    organizationId: string | null = null;
    groupId: string | undefined;
    teamId: string | undefined;

    proposalId: string | undefined;

    leadId: string | undefined;

    note: string | null = null;

    createdBy: string | undefined;
}
